import { getHtmlStyle } from '../transfer';

const container = {
  render(node, children) {
    const { props } = node;
    const { style, action, attrs } = props;

    const computeStyle = Object.assign({}, style);

    if ((action.actionCmd === 'browser' || action.actionCmd === 'web' || action.actionCmd === 'plugin') && action.actionData && 'javascript:;' !== action.actionData) {
      // 兼容配置链接时有url属性actionData值不会url的情况跳转情况
      if (action.actionCmd === 'web' && action.actionData && 'javascript:;' !== action.actionData && action.actionData.indexOf('http') !== 0 && attrs && attrs.url && attrs.url.indexOf('http') === 0) {
        return `<a target="_blank" href="${action.actionData}" style="${getHtmlStyle(computeStyle)}" onclick="window.open('${attrs.url}')">${children}</a>`;
      }
      return `<a target="_blank" href="${action.actionData}" style="${getHtmlStyle(computeStyle)}">${children}</a>`;
    }
    return `<div style="${getHtmlStyle(computeStyle)}">${children}</div>`;
  },
};

export default container;
